import { render, staticRenderFns } from "./dashboard-icon.vue?vue&type=template&id=59b334a0"
import script from "./dashboard-icon.vue?vue&type=script&lang=js"
export * from "./dashboard-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports